import { useState } from 'react';
import { Box, IconButton, Link, TextField, Button } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const BLUE = '#004df2';

export const normalizeUrl = (url) => {
    const trimmed = String(url || '').trim();
    if (!trimmed) return '';
    if (/^(https?:|mailto:)/i.test(trimmed)) return trimmed;
    return `https://${trimmed}`;
};

const LinkList = ({ links = [], onChange, addLabel = 'Add link' }) => {
    const [adding, setAdding] = useState(false);
    const [form, setForm] = useState({ label: '', url: '' });

    const add = () => {
        const url = normalizeUrl(form.url);
        if (!url) return;
        onChange([...links, { label: form.label.trim() || url, url }]);
        setForm({ label: '', url: '' });
        setAdding(false);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mt: 0.5 }}>
            {links.map((l, i) => (
                <Box key={`${l.url}-${i}`} sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                    <LinkIcon sx={{ fontSize: 14, color: BLUE, flexShrink: 0 }} />
                    <Link href={l.url} target="_blank" rel="noopener noreferrer" sx={{ fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {l.label || l.url}
                    </Link>
                    <IconButton size="small" title="Remove link" onClick={() => onChange(links.filter((_, x) => x !== i))}>
                        <DeleteIcon sx={{ fontSize: 14 }} />
                    </IconButton>
                </Box>
            ))}

            {adding ? (
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap', mt: 0.5 }}>
                    <TextField size="small" placeholder="Label (optional)" value={form.label}
                        onChange={(e) => setForm({ ...form, label: e.target.value })} sx={{ flex: '1 1 180px' }} />
                    <TextField size="small" placeholder="https://…" value={form.url}
                        onChange={(e) => setForm({ ...form, url: e.target.value })}
                        onKeyDown={(e) => { if (e.key === 'Enter') add(); }} sx={{ flex: '1 1 220px' }} />
                    <Button size="small" variant="contained" onClick={add}
                        sx={{ textTransform: 'none', backgroundColor: BLUE, '&:hover': { backgroundColor: '#0040c8' } }}>
                        Add
                    </Button>
                    <Button size="small" onClick={() => { setAdding(false); setForm({ label: '', url: '' }); }} sx={{ textTransform: 'none' }}>
                        Cancel
                    </Button>
                </Box>
            ) : (
                <Button size="small" startIcon={<AddIcon sx={{ fontSize: 14 }} />} onClick={() => setAdding(true)}
                    sx={{ textTransform: 'none', alignSelf: 'flex-start', color: BLUE, fontSize: 12.5 }}>
                    {addLabel}
                </Button>
            )}
        </Box>
    );
};

export default LinkList;
